import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import { SalesOrder } from "../../../../components/modules/sales/sales-order";
import SalesOrderMiddleware from "../../../../middleware/modules/sales/sales-order";
import i18n from "../../../../i18n";
import { Helmet } from "react-helmet";
// middlewares
const mapStateToProps = ({ auth, salesorder }) => ({
  isProcessing: salesorder.isProcessing,
  isError: salesorder.isError,
  errorMessage: salesorder.errorMessage,
  datalist: salesorder.data,
  showModal: salesorder.showModal,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      create: () => SalesOrderMiddleware.create(),
      reset: () => SalesOrderMiddleware.resetList(),
      search: (data) => SalesOrderMiddleware.list(data),
      update: (data) => SalesOrderMiddleware.update(data),
      delete: (id, search) => SalesOrderMiddleware.beforeDelete(id, search),
      getHelperFull: (id, search) =>
        SalesOrderMiddleware.getHelperFull(id, search),
    },
    dispatch
  );
};
class SalesOrderContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  };

  constructor(props) {
    super(props);
    this.deleteItem = this.deleteItem.bind(this);
    this.createItem = this.createItem.bind(this);
    this.updateItem = this.updateItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
    this.props.search(search);
  }

  deleteItem(id, search) {
    this.props.delete(id, search);
  }
  updateItem(id) {
    this.props.getHelperFull();
    this.props.update(id);
  }
  createItem() {
    this.props.create();
    this.props.getHelperFull();
  }
  render() {
    const { isProcessing, search, datalist, showModal } = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Sales Order List")}
          </title>
        </Helmet>
      <SalesOrder
        search={search}
        data={datalist}
        isProcessing={isProcessing}
        showModal={showModal}
        deleteItem={this.deleteItem}
        updateItem={this.updateItem}
        createData={this.createItem}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderContainer);
